import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useMutation } from "@tanstack/react-query";
import putSite from "../http/putSite";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useSiteUpdate = () => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);
  return useMutation(async (update: { siteId: string; payload: any }) =>
    putSite(
      await getAuthTokenBlocking(getToken, relogin),
      update.siteId,
      undefined,
      update.payload
    )
  );
};

export default useSiteUpdate;
